var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C40.1109 100 30.444 97.0676 22.2215 91.5735C13.999 86.0794 7.59043 78.2705 3.80604 69.1342C0.0216642 59.9979 -0.968502 49.9445 0.960758 40.2455C2.89002 30.5465 7.65206 21.6373 14.6447 14.6447C21.6373 7.65206 30.5465 2.89002 40.2455 0.960758C49.9445 -0.968502 59.9979 0.0216642 69.1342 3.80604C78.2705 7.59043 86.0794 13.999 91.5735 22.2215C97.0676 30.444 100 40.1109 100 50C100 63.2608 94.7322 75.9785 85.3553 85.3553C75.9785 94.7322 63.2608 100 50 100ZM50 7.14288C41.5237 7.14288 33.2377 9.6564 26.1899 14.3656C19.142 19.0748 13.6489 25.7682 10.4052 33.5993C7.16143 41.4304 6.31271 50.0476 7.96637 58.361C9.62002 66.6745 13.7018 74.3109 19.6954 80.3046C25.6891 86.2983 33.3255 90.38 41.639 92.0337C49.9525 93.6873 58.5696 92.8386 66.4007 89.5948C74.2318 86.3511 80.9252 80.858 85.6344 73.8102C90.3436 66.7623 92.8571 58.4764 92.8571 50C92.8571 38.6336 88.3419 27.7327 80.3046 19.6954C72.2673 11.6582 61.3664 7.14288 50 7.14288Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3925 71.4279L46.4282 51.4636V17.8564H53.5711V48.4993L71.4282 66.3921L66.3925 71.4279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.d38f96383d931d26e92d2c65b6c3ff94.svg";
export { ForwardRef as ReactComponent };